// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let QueryParams = require("../../reason/QueryParams.bs.js");

let param = QueryParams.ParamConfigs.withDefault(QueryParams.ParamConfigs.booleanParam, false);

let IsNew = QueryParams.UseQueryParam.Make(param);

function use() {
  return IsNew.use("is_new");
}

exports.param = param;
exports.IsNew = IsNew;
exports.use = use;
/* param Not a pure module */
